<template>
    <Layout>
        <b-row>
            <b-col xl="2" sm="3" v-if="showDefaultScreen">
                <Menu @back="handleBack"/>
            </b-col>
            <b-col xl="10" sm="9" v-if="showDefaultScreen">
                <Crumbs v-if="false" />
                <Documents
                v-if="isEditing == false"
                @edit="editDoc"
                @view="viewDocument"/>
                <ViewDocument @back="handleBack" :isNewDocument="isNewDocument" v-if="isEditing"/>
            </b-col>
        </b-row>
        
    </Layout>
</template>

<script>
import { layoutMethods } from '@/state/helpers'
import Menu from '@/components/widgets/green-menu.vue'
import Layout from "../../layouts/main-stripped";
import Crumbs from '@/components/widgets/breadcrumbs.vue';
import Documents from '@/components/client/sop/documentList.vue';
//import Edit from '@/components/client/sop/editDocument.vue'
import ViewDocument from '@/components/client/sop/viewDocument.vue'
export default {
    data:() => ({
        hideMenu: false,
        isEditing: false
    }),
    components:{
        Menu, Layout, Crumbs,
        Documents, ViewDocument
    },
    computed:{
        showDefaultScreen(){
            return true;
        }
    },
    methods:{
        ...layoutMethods,
        handleBack(){
            this.showDocumentsMenu();
            this.isEditing = false;
        },
        viewDocument(){

        },
        editDoc(id){
            this.showEditMenu();
            console.log(id);
            this.isNewDocument = false;
            this.isEditing = true;
        },
        //*set menu store state
        showDocumentsMenu(){
            this.updateMenuType({
                type: 'client_documents',
                showRoutes: false,
                showMenu: true,
            })
        },
        showEditMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'client_document_edit',
                showMenu: false,
                showRoutes: false,
            })
        },
    },
    mounted(){
        this.showDocumentsMenu();
    },
    beforeDestroy(){
        this.updateMenuType({
            type: null,
            showMenu: true,
            showRoutes: false,
        })
    },
}
</script>

<style>

</style>